module.exports = __WEBPACK_EXTERNAL_MODULE_40__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Vue","commonjs":"vue","commonjs2":"vue","amd":"vue"}
// module id = 40
// module chunks = 0